import React from "react"
import { BaseEmptyState, BaseEmptyStateProps } from "./BaseEmptyState"

type Props = {} & Omit<BaseEmptyStateProps, "type">

export const PrimaryEmptyState: React.FC<Props> = (props) => <BaseEmptyState type="primary" {...props} />
